import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core'
import { QuoteCartService } from '../../quote-services/quote-cart.service'
import { switchMap, filter, take } from 'rxjs/operators'
import { saveAs } from 'file-saver'
import {
  AuthService,
  User,
  GlobalMessageService,
  GlobalMessageType,
  TranslationService,
} from '@spartacus/core'
import {
  ActiveCartFacade,
  MultiCartFacade,
  OrderEntry,
} from '@spartacus/cart/base/root'
import { Observable, of } from 'rxjs'
import { Router, NavigationEnd } from '@angular/router'
import { FormControl, Validators } from '@angular/forms'
import { LaunchDialogService } from '@spartacus/storefront'
import { DatePipe } from '@angular/common'
import moment from 'moment'
import { QuoteStatus } from '../../../../models/status/status.model'
import { QuoteCheckoutService } from '../../quote-checkout/services/quote-checkout.service'
import { Item } from '../quote-cart-product/quote-cart-product.component'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { SnackbarService } from '../../../../shared/directive/snackBar/snackbar.service'
import { CommonService } from '../../../../shared/services/common.service'
import { SpinnerOverlayService } from '../../../../shared/components/spinner-overlay/spinner-overlay.service'
import { CalenderConfigService } from '../../../../shared/services/calender-config.service'
import { ShoppingCartService } from '../../../cart/cart-shared/cart.service'
import { BreadcrumbService } from '../../../../shared/components/breadcrumb/breadcrumb.service'
import { DialogResponse, VS_LAUNCH_CALLER } from '../../../config/dialog.config'
import { PRE_URL } from '../../../../shared/constants'
import { QuoteCartFacade } from '../../../cart/mini-cart/store/mini-quote-cart.facade'

import {
  Ecommerce,
  EcommerceItem,
  GTMDataLayer,
  GTMCartType
} from '../../../../shared/models/googleTagManager.model';
import {
  ItemListTypeEnum,
  GtmEvents,
  StoreTypeEnum,
} from '../../../../shared/enums/gtm.enum';
import { GoogleTagManagerService } from '../../../../shared/services/gtm.service';

@Component({
  standalone: false,
  selector: 'vs-view-cart',
  templateUrl: './view-cart.component.html',
  styleUrls: ['./view-cart.component.scss'],
  host: { class: 'QuoteCartPageTemplate' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewCartComponent implements OnInit {
  public cartId
  public cartStatus
  public userType
  user$: Observable<User>
  productData: any
  ProductList: any
  closeAddProduct = false
  showToggle = true
  cartData: any
  loading = false
  opnePopUp = false
  mySubscription: any
  cartLoaded = false
  cartData$: Observable<any>
  cartDataDate$: Observable<any>
  panelOpenState = true
  panelOpenStatex = true
  dateAll: string
  minDate = new Date()
  dateCheckAll = new FormControl('', [Validators.required])
  cartName
  cartDescription
  currentUser
  defaultRequestedDate: Date
  showPrice: boolean = true
  QuoteStatus = QuoteStatus
  reasonForQuoteArray$: Observable<any>
  reasonForQuote: any
  brandList: Object
  showAddProductLoader: boolean = false
  checkAll: boolean = false
  selectedItems: Item[] = []
  fastTrackEntries: [] = []
  private _items: Item[] = []
  filterWeekend = this.calenderConfigService.isFilterWeekend()
  checkQuoteType: boolean = false
  partPlaceholderFlag: boolean = false
  fasttrackPriceData: any
  getQuoteValue: any
  fastTrackData$: Observable<any>
  quoteCartStatus: any
  mergeEntries: any

  constructor(
    private quoteService: QuoteCartService,
    private auth: AuthService,
    protected activeCartService: ActiveCartFacade,
    private router: Router,
    public snackbar: SnackbarService,
    private commonService: CommonService,
    private launchDialogService: LaunchDialogService,
    public datepipe: DatePipe,
    private globalMessageService: GlobalMessageService,
    private quoteCheckoutService: QuoteCheckoutService,
    private spinnerOverlayService: SpinnerOverlayService,
    private cRef: ChangeDetectorRef,
    private calenderConfigService: CalenderConfigService,
    private shoppingCartService: ShoppingCartService,
    private breadCrumbService: BreadcrumbService,
    private translate: TranslationService,
    private userAccountFacade: UserAccountFacade,
    private multiCartService: MultiCartFacade,
    private gtmService: GoogleTagManagerService,
    private quoteCartFacade: QuoteCartFacade
  ) {
    this.user$ = this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          this.userType = 'current'
          this.cartId = sessionStorage.getItem('cartId-current')
          this.cartStatus = sessionStorage.getItem('cartStatus-current')
          if (!this.cartStatus) {
            this.cartStatus = 'empty'
            sessionStorage.setItem('cartStatus-current', 'empty')
          }
          return this.userAccountFacade.get()
        } else {
          this.userType = 'anonymous'
          this.cartId = sessionStorage.getItem('cartId-anonymous')
          this.cartStatus = sessionStorage.getItem('cartStatus-anonymous')
          if (!this.cartStatus) {
            this.cartStatus = 'empty'
            sessionStorage.setItem('cartStatus-anonymous', 'empty')
          }
          return of(undefined)
        }
      })
    )
    this.auth.isUserLoggedIn().subscribe(
      (success) => {
        this.quoteCartStatus = sessionStorage.setItem('quoteCartValue', 'true')
        let appliedDate
        this.router.events
          .pipe(
            filter((rs): rs is NavigationEnd => rs instanceof NavigationEnd)
          )
          .subscribe(
            (event) => {
              if (event.id === 1 && event.url === event.urlAfterRedirects) {
                appliedDate = sessionStorage.getItem('quoteCart')
              } else {
                appliedDate = sessionStorage.getItem('quoteCart-requestedDate')
                sessionStorage.setItem('quoteCart', appliedDate)
              }
              if (appliedDate) {
                const nextDate = new Date(appliedDate)
                // nextDate.setDate(nextDate.getDate() + 1);
                const defDate = this.datepipe.transform(nextDate, 'yyyy-MM-dd')
                this.dateCheckAll.setValue(
                  moment(nextDate).format('YYYY/MM/DD')
                )
                // this.dateCheckAll = appliedDate;
              }
              if (success) {
                this.userType = 'current'
                this.cartStatus = sessionStorage.getItem('cartStatus-current')
                if (!this.cartStatus) {
                  this.cartStatus = 'empty'
                }
                return
              } else {
                this.userType = 'anonymous'
                this.cartStatus = sessionStorage.getItem('cartStatus-anonymous')
                if (!this.cartStatus) {
                  this.cartStatus = 'empty'
                }
                return
              }
            },
            (error) => {
              this.globalMessageService.add(
                error,
                GlobalMessageType.MSG_TYPE_ERROR,
                5000
              )
              window.scrollTo(0, 0)
            }
          )
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )

    // Hack to refresh page without using window.location.reload()
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false
    }
    this.mySubscription = this.router.events.subscribe(
      (event) => {
        if (event instanceof NavigationEnd) {
          // Trick the Router into believing it's last link wasn't previously loaded
          this.router.navigated = false
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  ngOnInit(): void {
    this.commonService.getUserData().subscribe(
      (user) => {
        this.currentUser = user
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )
    sessionStorage.setItem('fastTrack', this.checkQuoteType.toString())
    this.commonService.getMessage.subscribe((message) => {
      if (message === 'logout') {
        sessionStorage.setItem('cartStatus-anonymous', 'empty')
        sessionStorage.setItem('cartId-anonymous', '')
      }
    })
    this.reasonForQuoteArray$ = this.quoteService.getQuoteReason(this.userType)
    this.reasonForQuoteArray$.subscribe(
      (res) => {
        this.reasonForQuote = res.reasonforQuote
        // if(this.reasonForQuote[0]){
        //   this.reasonForQuote[0].selected = true;
        // }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
    this.getCartData()
    this.breadCrumbService.setBreadCrumbs([])
    this.translate
      .translate('quoteCheckout.quoteCart')
      .subscribe((res: string) =>
        this.breadCrumbService.setBreadcrumbTitle(res)
      )
    // this.getCartForQty();
  }

  // Hack to refresh page without using window.location.reload()
  ngOnDestroy() {
    if (this.mySubscription) {
      this.mySubscription.unsubscribe()
    }
    if (this.quoteCheckoutService.checkSubmission) {
      this.quoteCheckoutService.checkSubmission.next(false)
    }
    this.quoteCartStatus = sessionStorage.setItem('quoteCartValue', 'false')
  }

  sendGTMViewCartEvent() {
    const viewcartItemsData: any[] = [];
    let totalValue = 0;
    this.cartData?.entries.forEach((itemEl, index) => {
      viewcartItemsData.push({
        item_id: itemEl?.product?.code,
        item_name: itemEl?.product?.name,
        index: index,
        item_list_id: ItemListTypeEnum.Cart,
        item_list_name: ItemListTypeEnum.Cart,
        price: itemEl?.totalPrice?.value,
        quantity: itemEl?.quantity,
        lead_time: (itemEl?.leadTime) ? itemEl?.leadTime : '',
      });
      totalValue += itemEl?.totalPrice?.value * itemEl?.quantity;
    });
    const viewCartDataLayer: GTMDataLayer = {
      event: GtmEvents.ViewCart,
      ecommerce: {
        currency: this.cartData?.entries[0]?.netPrice.currencyIso,
        value: totalValue,
        items: viewcartItemsData,
      },
      commerceType: GTMCartType.QUOTE_CART,
      cart_id: this.cartId
    };
    this.gtmService.sendEvent(viewCartDataLayer);
  }

  getBrands() {
    this.quoteService.getBrand(this.userType, this.cartId).subscribe(
      (success) => {
        this.brandList = success
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  dateChange(event) {
    var newData = event
      .toISOString()
      .slice(0, 19)
      .replace(/-/g, '/')
      .split('T')[0]
    let paramDate = newData.split('/')
    let newDate = moment(event).format('YYYY/MM/DD')

    this.dateCheckAll.setValue(newDate)
  }
  getCartData(event?) {
    this.cartId = sessionStorage.getItem('cartId-' + this.userType)
    this.getBrands()
    if (this.spinnerOverlayService.getOverlayRef()) {
      this.spinnerOverlayService.hide()
      this.spinnerOverlayService.show()
    } else{
      this.spinnerOverlayService.show()
    }

    this.cartData$ = this.quoteService
      .getCart(this.cartId, this.userType)
      .pipe(take(1))
    this.cartData$.pipe(take(1)).subscribe(
      (success: any) => {
        this.cartLoaded = true;
        this.cartData = success;
        this.sendGTMViewCartEvent();
        this.spinnerOverlayService.hide();
        this.cRef.detectChanges();
        this.getQuoteValue = sessionStorage.getItem('quoteCartValue')
        if (this.userType == 'current' && this.cartData['entries'] >= 1) {
          sessionStorage.setItem('cartId-current', success.code)
          this.cartId = success.code
          sessionStorage.setItem('cartStatus-current', 'added')
        }
        if (this.userType == 'anonymous' && this.cartData['entries'] >= 1) {
          sessionStorage.setItem('cartId-anonymous', success.guid)
          this.cartId = success.guid
          sessionStorage.setItem('cartStatus-anonymous', 'added')
        }
        this.productData = success.entries
        if(event == 'added'){ this.pushAddToCartEvent(this.productData[this.productData.length - 1], this.cartId) }
        this._items = this.productData
        if (this.productData.length < 1) {
          // this.deleteCart();
          this.cartStatus = 'empty'
          if (this.getQuoteValue === 'true') {
            this.cartStatus = 'empty'
            sessionStorage.setItem(
              'cartStatus-' + this.userType,
              this.cartStatus
            )
          }
        } else {
          this.cartStatus = 'added'
        }
        if (this.checkQuoteType && this.productData.length > 3) {
          this.globalMessageService.add(
            { key: 'quoteCart.fastTrackOnlyThreeParts' },
            GlobalMessageType.MSG_TYPE_WARNING,
            7000
          )
          window.scrollTo(0, 0)
          return
        }
        for (var i = 0; i < this.productData.length; i++) {
          if (!this.productData[i].isCatalogItem) {
            this.showPrice = false
            this.partPlaceholderFlag = true
            if (this.checkQuoteType) {
              this.globalMessageService.add(
                { key: 'quoteCart.removeNonCatalogParts' },
                GlobalMessageType.MSG_TYPE_WARNING,
                10000
              )
              window.scrollTo(0, 0)
              return
            }
          }
        }
        // sessionStorage.setItem('cartStatus-'+this.userType, this.cartStatus);
        if (this.cartData?.quoteCartType === this.QuoteStatus.EDIT) {
          this.globalMessageService.add(
            {
              key: 'quoteCart.quoteBeingEdited',
              params: {
                sapQuoteJson: this.cartData.sapQuoteId,
              },
            },
            GlobalMessageType.MSG_TYPE_INFO,
            10000
          )
        }
        if (this.cartData?.vsNonSellableProducts?.length > 0) {
          this.openNonSellableDialog()
        }
      },
      (error) => {
        this.globalMessageService.add(
          { key: 'quoteCart.issueQuoteCart' },
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
        this.spinnerOverlayService.hide()
      }
    )
  }
  openNonSellableDialog() {
    const componentdata = {
      nonSellableProducts: this.cartData.vsNonSellableProducts,
    }

    const nonSellableQuoteDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.NON_SELLABLE_QUOTE,
      undefined,
      undefined,
      componentdata
    )
    if (nonSellableQuoteDialog) {
      nonSellableQuoteDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose
        .pipe(
          filter(
            (dialogResponse: DialogResponse) =>
              dialogResponse?.type == VS_LAUNCH_CALLER.NON_SELLABLE_QUOTE
          ),
          take(1)
        )
        .subscribe((value) => {
          if (value?.reason == 'ok-non-sellable-quote') {
            this.shoppingCartService
              .acknowledgeNonSellProducts(this.cartId)
              .subscribe(
                (res) => {
                  if (this.cartData?.entries?.length <= 0) {
                    this.deleteCart()
                  }
                },
                (error) => {
                  this.globalMessageService.add(
                    error,
                    GlobalMessageType.MSG_TYPE_ERROR,
                    5000
                  )
                  window.scrollTo(0, 0)
                }
              )
          }
          this.cRef.detectChanges()
        })
    }
  }
  toggleAddProduct() {
    this.closeAddProduct = !this.closeAddProduct
  }
  receiveMessage(event) {
    this.cartStatus = event
    if (this.cartStatus === 'added') {
      // this.snackbar.open('Product added into the Quote Cart', 'done');
      this.getCartData()
    }
  }
  cancelAddingLoaded(event) {
    this.toggleAddProduct()
  }
  refreshList(event) {
    // this.cartStatus = event;
    // sessionStorage.setItem('cartStaus', this.cartStatus);
    this.getCartData(event)
    // this.router.navigate(['quote/cart']);
    // window.location.reload();
  }
  toggleButton() {
    this.showToggle = !this.showToggle
  }
  deleteCart() {
    this.loading = true
    this.quoteService
      .deleteCart(this.userType, this.cartId)
      .pipe(take(1))
      .subscribe((success) => {
        // this.snackbar.open('Product(s) has been removed successfully');
        if (this.userType == 'current') {
          sessionStorage.setItem('cartId-current', '')
          sessionStorage.setItem('cartStatus-current', 'empty')
        }
        if (this.userType == 'anonymous') {
          sessionStorage.setItem('cartId-anonymous', '')
          sessionStorage.setItem('cartStatus-anonymous', 'empty')
        }

        this.removeItemsEvent(this.selectedItems);

        sessionStorage.setItem('quoteCart-requestedDate', '')
        this.loading = false
        this.partPlaceholderFlag = false
        var k
        
        this.quoteService.getCart(k, this.userType).subscribe(
          (success) => {
            if (this.userType === 'current') {
              this.cartId = success['code']
            } else {
              this.cartId = success['guid']
            }
            sessionStorage.setItem('cartId-' + this.userType, this.cartId)
            sessionStorage.setItem('cartStatus-' + this.userType, 'empty')
            this.quoteService.sendCartId(this.cartId)
            this.router.navigate(['quote/cart'])
            this.quoteCartFacade.loadCart();
          },
          (error) => {
            this.globalMessageService.add(
              error,
              GlobalMessageType.MSG_TYPE_ERROR,
              5000
            )
            window.scrollTo(0, 0)
          }
        )
      })
  }
  deleteCartItem() {
    const itemsToDelete = []
    this.selectedItems.sort((a, b) => (a.entryNumber < b.entryNumber ? 1 : -1))
    this.selectedItems.forEach((itemEl) => {
      itemsToDelete.push(itemEl.entryNumber)
    })
    this.spinnerOverlayService.show('Loading Cart')
    this.quoteService
      .deleteMultipleQuoteEntries(this.userType, this.cartId, itemsToDelete)
      .pipe(take(1))
      .subscribe(
        (response) => {
          this.removeItemsEvent(this.selectedItems);
          this.selectedItems = []
          this.spinnerOverlayService.hide()
          this.partPlaceholderFlag = false
          this.getCartData()
          this.globalMessageService.add(
            { key: 'quoteCart.itemsRemoved' },
            GlobalMessageType.MSG_TYPE_CONFIRMATION,
            5000
          )
          window.scrollTo(0, 0)
          this.quoteCartFacade.loadCart();
        },
        (error) => {
          this.spinnerOverlayService.hide()
          this.globalMessageService.add(
            { key: 'quoteCart.errorOccured' },
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }
  onEntryCheck(e) {
    if (e.checked) {
      this.selectedItems.push(this._items[e.entryNumber])
    } else {
      this.selectedItems = this.selectedItems.filter(
        (item) => item.entryNumber !== e.entryNumber
      )
    }
  }
  checkAllEntries(event, entries) {
    this.checkAll = event.target.checked
    if (this.checkAll) this.selectedItems = entries
    else this.selectedItems = []
  }
  openDeleteAllPopUp(val) {
    if (val !== true && this.selectedItems.length <= 0) {
      this.globalMessageService.add(
        { key: 'quoteCart.selectOneProduct' },
        GlobalMessageType.MSG_TYPE_INFO,
        10000
      )
      window.scroll(0, 0)
      return
    } else {
      const componentdata = {
        product: val !== true ? this.productData : null,
      }
      const deleteQuoteCartDialog = this.launchDialogService.openDialog(
        VS_LAUNCH_CALLER.DELETE_QUOTE_CART,
        undefined,
        undefined,
        componentdata
      )
      if (deleteQuoteCartDialog) {
        deleteQuoteCartDialog.pipe(take(1)).subscribe((value) => {})
        this.launchDialogService.dialogClose
          .pipe(
            filter(
              (dialogResponse: DialogResponse) =>
                dialogResponse?.type == VS_LAUNCH_CALLER.DELETE_QUOTE_CART
            ),
            take(1)
          )
          .subscribe((value) => {
            if (value?.reason == 'delete-quote-cart') {
              if (
                val === false &&
                this.selectedItems.length != this.productData.length
              ) {
                this.deleteCartItem()
              } else {
                this.deleteCart()
              }
            }
          })
      }
    }
    // this.opnePopUp = !this.opnePopUp;
  }
  openSaveCartModal() {
    const componentdata = {}

    const savedQuoteCartDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.SAVED_QUOTE_CART,
      undefined,
      undefined,
      componentdata
    )
    if (savedQuoteCartDialog) {
      savedQuoteCartDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose
        .pipe(
          filter(
            (dialogResponse: DialogResponse) =>
              dialogResponse?.type == VS_LAUNCH_CALLER.SAVED_QUOTE_CART
          ),
          take(1)
        )
        .subscribe((res) => {
          if (res?.data?.value) {
            this.cartName = res?.data?.value?.cartName
            this.cartDescription = res?.data?.value?.description
            this.saveQuoteCart()
          }
        })
    }
  }
  saveQuoteCart() {
    this.spinnerOverlayService.show('Loading Cart')
    this.commonService
      .patchData(
        `${PRE_URL}/users/${this.currentUser.uid}/carts/${this.cartId}/save`,
        {},
        {
          params: {
            saveCartName: this.cartName,
            saveCartDescription: this.cartDescription,
            isRfqCart: true,
          },
          responseType: 'text',
        }
      )
      .subscribe(
        (response: any) => {
          if (Number(response)) {
            let id
            id = response
            this.cartId = id
            sessionStorage.setItem('cartId-current', id)
            this.selectedItems = []
            this.spinnerOverlayService.hide()
            this.partPlaceholderFlag = false
            this.globalMessageService.add(
              {
                key: 'quoteCart.cartSaveSuccess',
                params: { cartName: this.cartName },
              },
              GlobalMessageType.MSG_TYPE_CONFIRMATION,
              5000
            )
            window.scrollTo(0, 0)
            this.quoteService.sendCartId(id)
            sessionStorage.setItem('cartStatus-current', 'empty')
            this.router.navigate(['quote/cart'])
            this.quoteCartFacade.loadCart();
          } else {
            this.spinnerOverlayService.hide()
            this.globalMessageService.add(
              { key: 'quoteCart.invalidCartNameErr' },
              GlobalMessageType.MSG_TYPE_ERROR,
              5000
            )
            window.scrollTo(0, 0)
          }
        },
        (error) => {
          this.spinnerOverlayService.hide()
          this.globalMessageService.add(
            { key: 'quoteCart.errorOccured' },
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }

  productAddedInLoadedCart(event) {
    this.toggleAddProduct()
    this.refreshList(event)
  }
  applyDateToAll() {
    if(this.dateCheckAll.value){
      this.showAddProductLoader = true
      this.dateAll = null
      this.dateAll = this.dateCheckAll.value.replace(/-/g, '/')

      this.cRef.detectChanges()
      this.defaultRequestedDate = new Date(this.dateAll)
      sessionStorage.setItem('quoteCart-requestedDate', this.dateCheckAll.value)
      sessionStorage.setItem('quoteCart', this.dateCheckAll.value)

      const requestObj = {
        customerRequestedDate: this.dateAll,
      }
      if (this.userType === 'current') {
        this.cartId = sessionStorage.getItem('cartId-current')
      }
      if (this.userType === 'anonymous') {
        this.cartId = sessionStorage.getItem('cartId-anonymous')
      }
      this.quoteService.sendApplyToAll(this.dateAll)
      this.cartData$ = this.quoteService.dateApplyAll(
        this.userType,
        this.cartId,
        requestObj
      )
      this.cartData$.pipe(take(1)).subscribe(
        (success) => {
          this.showAddProductLoader = false
          this.cartData = success
          this.cRef.detectChanges()
          this.globalMessageService.add(
            { key: 'quoteCart.DateAppliedToLineItems' },
            GlobalMessageType.MSG_TYPE_INFO,
            5000
          )
        },
        (error) => {
          this.showAddProductLoader = false

          this.cRef.detectChanges()
          this.globalMessageService.add(
            { key: 'quoteCart.issueOccuredWhileApplyingDate' },
            GlobalMessageType.MSG_TYPE_ERROR,
            7000
          )
        }
      )
    } else{
      this.globalMessageService.add(
        { key: 'quoteCart.issueDateNotSelected' },
        GlobalMessageType.MSG_TYPE_ERROR,
        3500
      )
    }
    // this.getCartData()
    // this.cRef.detectChanges();
  }
  checkQuoteEntries(event, entries) {
    // this.partPlaceholderFlag = false;
    this.checkQuoteType = event.target.checked
    sessionStorage.setItem('fastTrack', this.checkQuoteType.toString())
    if (this.checkQuoteType) {
      this.fastTrackEntries = entries
      this.fastTrackPriceCall()
      if (this.fastTrackEntries.length > 3) {
        this.globalMessageService.add(
          { key: 'quoteCart.fastTrackOnlyThreeParts' },
          GlobalMessageType.MSG_TYPE_WARNING,
          7000
        )
        window.scrollTo(0, 0)
        return
      } else if (this.partPlaceholderFlag == true) {
        this.globalMessageService.add(
          { key: 'quoteCart.removeNonCatalogParts' },
          GlobalMessageType.MSG_TYPE_WARNING,
          7000
        )
        window.scrollTo(0, 0)
        return
      }
    }
  }
  fastTrackPriceCall() {
    const apiParams = ['products', 'productCode']
    let lastPart = `checkPriceAndAvailability?`
    lastPart += `productCode=EXPED`
    apiParams.push(lastPart)
    this.spinnerOverlayService.show()
    const apiUrl = this.commonService.constructUrl(apiParams)
    let paylod = {
      customerRequestedDate: '',
      quantity: 1,
      selectedPlant: null,
    }
    this.fastTrackData$ = this.commonService.postData(apiUrl, paylod)
    this.fastTrackData$.subscribe(
      (data) => {
        this.fasttrackPriceData = data
        this.spinnerOverlayService.hide()
      },
      (error) => {
        this.spinnerOverlayService.hide()
        this.globalMessageService.add(
          { key: 'quoteCart.unknownErrorOccured' },
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scrollTo(0, 0)
      }
    )
  }
  openFasttrackModal() {
    // if (!this.fasttrackQuoteDialog) {
    const componentdata = {
      data: this.fasttrackPriceData.price,
    }

    const fasttrackQuoteDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.FASTTRACK_QUOTE,
      undefined,
      undefined,
      componentdata
    )
    if (fasttrackQuoteDialog) {
      fasttrackQuoteDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose
        .pipe(
          filter(
            (dialogResponse: DialogResponse) =>
              dialogResponse?.type == VS_LAUNCH_CALLER.FASTTRACK_QUOTE
          ),
          take(1)
        )
        .subscribe((value) => {
          if (value?.reason == 'submit-fasttrack-quote') this.submit()
        })
    }
    // }
  }
  viewCheckout() {
    if (this.checkQuoteType) {
      this.openFasttrackModal()
    } else if (this.cartData?.entries?.length > 150) {
      let removeCount = this.cartData?.entries?.length - 150
      let errorMsg
      errorMsg = 'quoteCart.maxQuoteLimit2'
      this.globalMessageService.add(
        {
          key: errorMsg,
          params: {
            removeCountJson: removeCount,
            entryLength: this.cartData?.entries?.length,
          },
        },
        GlobalMessageType.MSG_TYPE_ERROR,
        5000
      )
      window.scrollTo(0, 0)
      return
    } else {
      this.submit()
    }
  }
  submit() {
    let count = 0
    let EntryType = 0

    for (let i = 0; i < this.cartData.entries.length; i++) {
      if (
        this.cartData.entries[i].customerRequestedDate == undefined ||
        this.cartData.entries[i].customerRequestedDate == ''
      ) {
        this.globalMessageService.add(
          { key: 'quoteCart.errorShipDate' },
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      } else if (
        this.cartData.entries[i].leadTime == undefined ||
        this.cartData.entries[i].leadTime == ''
      ) {
        this.globalMessageService.add(
          { key: 'quoteCart.errorLeadTime' },
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
      else if (
        this.cartData.entries[i].quoteCartEntryType == undefined &&
        this.cartData.entries[i].isCatalogItem === false
      ) {
        if (
          (this.cartData.entries[i]?.productType
            ?.toLowerCase()
            .includes('part') ||
            this.cartData.entries[i]?.productType
              ?.toLowerCase()
              .includes('parts')) &&
          !this.cartData.entries[i]?.serialNumber
        ) {
          this.globalMessageService.add(
            { key: 'quoteCart.enterSerialNumber' },
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        } else if (
          this.cartData.entries[i].brandName &&
          this.cartData.entries[i]?.productType &&
          this.cartData.entries[i]?.productType != ''
        ) {
          count++
          EntryType++
          if (count == this.cartData.entries.length) {
            this.getEligibleBuyCartMergeEntries();
            count = 0
            EntryType = 0
            break
          }
        } else {
          this.globalMessageService.add(
            { key: 'quoteCart.addBrandName' },
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      } else {
        EntryType++
        count++
        if (EntryType == this.cartData.entries.length) {
          this.getEligibleBuyCartMergeEntries();
          count = 0
          EntryType = 0
          break
        }
      }
    }
  }
  
  getEligibleBuyCartMergeEntries() {
    this.mergeEntries = [];
    this.spinnerOverlayService.show();
    
    this.quoteService
      .getEligibleMergeQuoteEntries(this.cartId)
      .subscribe(
        (res: any) => {
          this.spinnerOverlayService.hide();
          if(res?.entries?.length > 0) {
            this.mergeEntries = res?.entries;
            this.openMergeQuoteCartCheckoutDialog();
          } else{
            this.setGTMTagsForCheckoutBegin();
            this.router.navigate(['quote/checkout']);
          }
        },
        (err) => {
          this.spinnerOverlayService.hide();
          this.globalMessageService.add(
            err.error.errors[0].message,
            GlobalMessageType.MSG_TYPE_ERROR,
            10000
          );
          window.scroll(0, 0);
        }
      )
  }

  mergeEligibleBuyCartEntries() {
    this.spinnerOverlayService.show();
    
    this.quoteService
      .mergeQuoteCartEntries(this.cartId, this.mergeEntries)
      .subscribe(
        (res: any) => {
          this.spinnerOverlayService.hide();
          this.quoteCartFacade.loadCart();
          this.setGTMTagsForCheckoutBegin();
          this.router.navigate(['quote/checkout']);
        },
        (err) => {
          this.spinnerOverlayService.hide();
          this.globalMessageService.add(
            err.error.errors[0].message,
            GlobalMessageType.MSG_TYPE_ERROR,
            10000
          );
          window.scroll(0, 0);
        }
      )
  }

  openMergeQuoteCartCheckoutDialog() {
    const componentdata = {
      cart: this.cartData,
      userType: this.userType,
      cartType: 'QUOTE_CART'
    }

    const mergeCheckoutCartDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.MERGE_CHEKOUT_CART_ITEMS,
      undefined,
      undefined,
      componentdata
    )
    if (mergeCheckoutCartDialog) {
      mergeCheckoutCartDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose
        .pipe(
          filter(
            (dialogResponse: DialogResponse) =>
              dialogResponse?.type == VS_LAUNCH_CALLER.MERGE_CHEKOUT_CART_ITEMS
          ),
          take(1)
        )
        .subscribe((value) => {
          if (value?.reason == 'merge-checkout-cart') {
            this.mergeEligibleBuyCartEntries();
          } else if (value?.reason == 'no-merge-checkout-cart') {
            this.setGTMTagsForCheckoutBegin();
            this.router.navigate(['quote/checkout']);
          }
        })
    }
  }

  getCartForQty() {
    this.cartData$ = this.quoteService.getCart(this.cartId, this.userType)
  }

  checkForObsoleteProducts(cartData) {
    for (let entry of cartData.entries) {
      if (entry.product.obsoleteProductFlag) {
        return true
      }
    }
    return false
  }
  deleteProductFromList(event) {
    this.cartData.entries.forEach((element, index) => {
      if (element.entryNumber == event) {
        this.cartData.entries.splice(index, 1)
        this.partPlaceholderFlag = false
        this.getCartData()
        this.cRef.detectChanges()
        return
      }
    })
  }
  deleteLoading(value) {
    if (value) {
      this.spinnerOverlayService.show()
    } else this.spinnerOverlayService.hide()
  }
  downloadXLS() {
    this.quoteService.downloadQuoteCrt(this.userType, this.cartId).subscribe(
      (res) => {
        if (res !== null && res !== undefined) {
          const currentDate = this.datepipe.transform(new Date(), 'yyyyMMdd')
          let fileName = 'RFQ_Cart_' + currentDate
          const blob = new Blob([res], { type: 'application/vnd.ms.excel' })
          const file = new File([blob], fileName + '.xlsx', {
            type: 'application/vnd.ms.excel',
          })
          saveAs(file)
        } else {
          this.globalMessageService.add(
            { key: 'quoteCart.errorDownloadingQuoteCart' },
            GlobalMessageType.MSG_TYPE_ERROR,
            10000
          )
        }
      },
      (error) => {
        this.globalMessageService.add(
          { key: 'quoteCart.errorDownloadingQuoteCart' },
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
      }
    )
  }

  removeItemsEvent(productData){
    const removedItemsData: any[] = [];
    let totalValue = 0;
    productData.forEach((itemEl) => {
      removedItemsData.push({
        item_id: itemEl?.product?.code,
        item_name: itemEl?.product?.name,
        index: itemEl.entryNumber,
        item_list_id: ItemListTypeEnum.Cart,
        item_list_name: ItemListTypeEnum.Cart,
        price: itemEl?.totalPrice?.value,
        quantity: itemEl?.quantity,
        lead_time: (itemEl?.leadTime) ? itemEl?.leadTime : '',
      });
      totalValue += itemEl.totalPrice.value;
      const removeFromCartDataLayer: GTMDataLayer = {
        event: GtmEvents.RemoveFromCart,
        ecommerce: {
          currency: itemEl.basePrice.currencyIso,
          value: totalValue,
          items: removedItemsData,
        },
        commerceType: GTMCartType.QUOTE_CART,
        cart_id: this.cartId
      };
      this.gtmService.sendEvent(removeFromCartDataLayer);
    });
  }

  setGTMTagsForCheckoutBegin() {
    let items: EcommerceItem[] = [];
    if (this.cartData?.entries.length > 0) {
      this.cartData?.entries.forEach((item, i) => {
        let eachitem: EcommerceItem = {
          item_id: item?.product?.code,
          item_name: item?.product?.name,
          index: i,
          item_list_id: ItemListTypeEnum.Cart,
          item_list_name: ItemListTypeEnum.Cart,
          price: item?.netPrice?.value,
          quantity: item?.quantity,
          lead_time: (item?.leadTime) ? item?.leadTime : ''
        };
        items.push(eachitem);
      });
    }

    let checkoutBeginEcommerce: Ecommerce = {
      currency: this.cartData?.totalPrice?.currencyIso,
      value: this.cartData?.totalPrice?.value ?? 0,
      items: items,
    };

    let checkoutBeginDataLayer: GTMDataLayer = {
      event: GtmEvents.BeginCheckout,
      ecommerce: checkoutBeginEcommerce,
      commerceType: GTMCartType.QUOTE_CART,
      cart_id: this.cartId
    };
    this.gtmService.sendEvent(checkoutBeginDataLayer);
  }

  pushAddToCartEvent(productData, cartId) {
    const item: EcommerceItem = {
      price: productData?.netPrice?.value,
      quantity: productData.quantity,
      item_id: productData?.product.code,
      item_name: productData?.product.name,
      item_list_id: ItemListTypeEnum.ProductDetail,
      item_list_name: ItemListTypeEnum.ProductDetail,
      item_category: productData?.product?.categories[0]?.name ?? '',
      item_category2: productData?.product?.categories[1]?.name ?? '',
      item_category3: productData?.product?.categories[2]?.name ?? '',
      item_category4: productData?.product?.categories[3]?.name ?? '',
      item_category5: productData?.product?.categories[4]?.name ?? '',
      index: 0,
    };

    const eventData: Ecommerce = {
      currency: productData?.netPrice?.currencyIso || '',
      value:
        productData?.netPrice?.value *
          productData.quantity || '',
      items: [item],
    };
    const event: GTMDataLayer = {
      event: GtmEvents.AddToCart,
      ecommerce: eventData,
      commerceType: GTMCartType.QUOTE_CART,
      cart_id: cartId
    };
    this.gtmService.sendEvent(event);
  }
}
